import { z } from 'zod';

export const MIN_AGE = 13;
export const MAX_AGE = 100;

export const MIN_BIRTH_YEAR = new Date().getFullYear() - MAX_AGE;
export const MAX_BIRTH_YEAR = new Date().getFullYear() - MIN_AGE;

export const getBirthYearOptions = () =>
  Array.from(
    { length: MAX_BIRTH_YEAR - MIN_BIRTH_YEAR + 1 },
    (_, i) => MAX_BIRTH_YEAR - i,
  );

export const ageSchema = z
  .number()
  .min(MIN_BIRTH_YEAR, {
    message: 'Please enter a valid birth year',
  })
  .max(MAX_BIRTH_YEAR, {
    message: `You must be at least ${String(MIN_AGE)} years old`,
  });
